import React, {Component} from 'react';
import {Row, Col, ControlLabel, Form, FormGroup, ButtonToolbar, FormControl, Checkbox} from "react-bootstrap";
import {TopButtonCancel, TopButtonSave} from "../../../../componentsTopsa/buttons/TopButtons";
import ValidatorMessages from "../../../../shared/validatorMessages/ValidatorMessages";
import {TopSelect} from "../../../../componentsTopsa/selects/TopSelects";
import Dropzone from "react-dropzone";
import Validator from "../../../../utilities/Validator";

export default class SzablonForm extends Component {
    constructor(props) {
        super(props);

        this.state = {
            dostep: {value: 'PUBLIC', label: 'PUBLIC'},
            dostepy: [
                {value: 'PRIVATE', label: 'PRIVATE'},
                {value: 'PUBLIC', label: 'PUBLIC'}
            ],
            slug: '',
            opis: '',
            plik: null,
            validatorMessages: []
        };

        this.onChangeDostep = this.onChangeDostep.bind(this)
        this.onDropSkan = this.onDropSkan.bind(this)

    }

    componentDidMount() {

    }

    componentWillReceiveProps() {
        this.setState({
            dostep: {value: 'PUBLIC', label: 'PUBLIC'},
            slug: this.props.szablon.slug,
            opis: this.props.szablon.opis,
            plik: {
                dane: this.props.szablon.dane,
                nazwa: this.props.szablon.nazwa,
                typ: this.props.szablon.typ,
                rozmiar: this.props.szablon.rozmiar
            }
        })
    }

    onChangeDostep(e) {
        this.setState({dostep: e})
    }

    onChangeOpis(e) {
        if(Validator.validateLenghtWithClearing(e.target.value, 100,'inputOpis', this.state.opis))
        this.setState({opis: e.target.value})
    }

    onChangeSlug(e) {
        if(Validator.validateLenghtWithClearing(e.target.value,100,'inputSlug',this.state.slug))
        this.setState({slug: e.target.value})
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    onClickZapisz() {
        this.state.validatorMessages = []
        let poprawne = true

        if (!Boolean(this.state.opis)) {
            this.dodajDoValidatorMessages('Nie uzupełniono opisu')
            poprawne = false
        }
        if (!Boolean(this.state.slug)) {
            this.dodajDoValidatorMessages('Nie uzupełniono pola slug')
            poprawne = false
        }else{
            if(!this.state.slug.match(/^[a-z0-9]+(?:-[a-z0-9]+)*$/)){
                this.dodajDoValidatorMessages('W polu slug można używać tylko liter (bez polskich znaków), cyfr oraz znaku -')
                poprawne = false
            }
        }
        if (!Boolean(this.state.plik)) {
            this.dodajDoValidatorMessages('Nie załączono pliku')
            poprawne = false
        }

        if (poprawne) {
            let obj = {
                "dane": this.state.plik.dane,
                "nazwa": this.state.plik.nazwa,
                "typ": this.state.plik.typ,
                "rozmiar": this.state.plik.rozmiar,
                "dokumentId": -1,
                "dokumentTyp": "STRONA_WPIS",
                "dostep": this.state.dostep.value,
                "opis": this.state.opis,
                "slug": this.state.slug,
            }

            this.props.onClickDodaj(obj)
        }

    }

    onClickEdytuj() {
        this.state.validatorMessages = []
        let poprawne = true

        if (!Boolean(this.state.opis)) {
            this.dodajDoValidatorMessages('Nie uzupełniono opisu')
            poprawne = false
        }
        if (!Boolean(this.state.slug)) {
            this.dodajDoValidatorMessages('Nie uzupełniono pola slug')
            poprawne = false
        }
        if (!Boolean(this.state.plik)) {
            this.dodajDoValidatorMessages('Nie załączono pliku')
            poprawne = false
        }

        if (poprawne) {
            let obj = {
                "dane": this.state.plik.dane,
                "nazwa": this.state.plik.nazwa,
                "typ": this.state.plik.typ,
                "rozmiar": this.state.plik.rozmiar,
                "dokumentTyp": "STRONA_WPIS",
                "dokumentId": -1,
                "dostep": this.state.dostep.value,
                "opis": this.state.opis,
                "slug": this.state.slug,
            }

            this.props.onClickEdytuj(obj)
        }

    }

    onDropSkan(e) {
        let dokument = e[0]

        if (dokument.size > 5252880) {
            alert('Rozmiar pliku jest za duży! Max 5MB')
        } else {
            const promise = new Promise((resolve, reject) => {
                const reader = new FileReader()

                reader.readAsDataURL(dokument)

                reader.onload = () => {
                    if (!!reader.result) {
                        resolve(reader.result)
                    }
                    else {
                        reject(Error("Failed converting to base64"))
                    }
                }

            })
            promise.then(result => {
                // dispatch or do whatever you need with result

                let przecinek = result.indexOf(',');
                let skrocony = result.substr(przecinek + 1, result.length - 1)
                this.setState({
                    plik:
                        {
                            "localid": (new Date().toISOString()) + (Math.floor(Math.random() * 1000 + 1)),
                            "dane": skrocony,
                            "nazwa": dokument.name,
                            "typ": dokument.type,
                            "rozmiar": dokument.size,
                            "dokumentTyp": "STRONA_WPIS"
                        }
                })


            }, err => {
                console.log(err)
                alert('Błąd przy próbie załadowania dokumentu')
            })
        }

    }

    render() {
        return (
            <div>
                <fieldset>
                    <div
                        className={'fieldset-label'}>{this.props.szablon !== null ? 'Edytuj szablon ' + this.props.szablon.slug : 'Dodaj szablon'}</div>
                    <Form horizontal={true}>
                        <FormGroup>
                            <Col xs={12} lg={12}>
                                <Row>
                                    <Col xs={12} lg={2}>
                                        <ControlLabel>
                                            Dostęp <span style={{color: 'red'}}>*</span>
                                        </ControlLabel>
                                        <TopSelect onChange={this.onChangeDostep}
                                                   value={this.state.dostep}
                                                   options={this.state.dostepy}
                                                   clearable={false}
                                                   disabled={true}
                                        />
                                    </Col>
                                    <Col xs={12} lg={10}>
                                        <ControlLabel>
                                            Plik szablonu <span style={{color: 'red'}}>*</span>
                                        </ControlLabel>
                                        <div>
                                            <section className={'dropzoneSection'} style={{display: 'inline-block'}}>
                                                <div className="dropzone" style={{
                                                    border: '1px dotted #aaa',
                                                    borderRadius: '3px',
                                                    cursor: 'pointer',
                                                    width: '100%',
                                                    lineHeight: '34px',
                                                    padding: '0 10px',
                                                    marginLeft: '5px'
                                                }}>
                                                    <Dropzone onDrop={this.onDropSkan} style={{}} multiple={true}>
                                                    <span style={{display: 'inline-block'}}>
                                                        {
                                                            Boolean(this.state.plik) ?
                                                                this.state.plik.nazwa
                                                                :
                                                                'Kliknij lub przeciągnij plik aby wybrać'
                                                        }
                                                    </span>
                                                    </Dropzone>
                                                </div>
                                            </section>
                                            {
                                                Boolean(this.state.plik) ?
                                                    <span style={{
                                                        display: 'inline-block',
                                                        marginLeft: '15px',
                                                        color: 'firebrick',
                                                        fontSize: '12px',
                                                        fontWeight: 'bold',
                                                        cursor: 'pointer'
                                                    }}
                                                          onClick={() => {
                                                              this.setState({plik: null})
                                                          }}
                                                    >
                                                            <i className={'fa fa-trash'}></i> Kliknij aby usunąć
                                                        </span>
                                                    :
                                                    ''
                                            }
                                        </div>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs={12} lg={3}>
                                        <ControlLabel>
                                            Opis <span style={{color: 'red'}}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.opis.length}/100 znaków</span>
                                        </ControlLabel>
                                        <FormControl value={this.state.opis} onChange={(e) => this.onChangeOpis(e)}
                                                     id={'inputOpis'}/>
                                    </Col>
                                    <Col xs={12} lg={3}>
                                        <ControlLabel>
                                            Slug <span style={{color: 'red'}}>*</span> <span style={{fontSize:'12px', color:'grey',fontStyle:'italic', fontWeight:'normal'}}>{this.state.slug.length}/100 znaków</span>
                                        </ControlLabel>
                                        <FormControl value={this.state.slug} onChange={(e) => this.onChangeSlug(e)}
                                                     id={'inputSlug'}/>
                                    </Col>
                                    <Col xs={12} lg={3}>
                                        <div className={'add-label-margin'}>
                                        </div>
                                        <ButtonToolbar>
                                            <TopButtonCancel onClick={() => {
                                                this.props.handleClickAnuluj()
                                            }}/>
                                            <TopButtonSave
                                                onClick={this.props.szablon !== null ? () => this.onClickEdytuj() : () => this.onClickZapisz()}/>
                                        </ButtonToolbar>
                                    </Col>
                                </Row>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12}>
                                <ValidatorMessages messages={this.state.validatorMessages}/>
                            </Col>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/administracja/szablony/components/SzablonForm.js